import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './form-layout.css';

const FormItem = ({ children, isGroupedItem, isCondensed }) => {
    const itemClass = cx(styles.item, {
        [styles.isGroupedItem]: isGroupedItem,
        [styles.isCondensed]: isCondensed,
    });

    return <div className={itemClass}>{children}</div>;
};

const FormFieldset = ({ children }) => <fieldset>{children}</fieldset>;

const FormGroup = ({ children, isWeightedRight, isWeightedLeft, isCondensed }) => {
    const groupClass = cx(styles.group, {
        [styles.isWeightedRight]: isWeightedRight,
        [styles.isWeightedLeft]: isWeightedLeft,
    });

    return (
        <div role="group" className={groupClass}>
            {React.Children.map(children, (child) => React.cloneElement(child, { isGroupedItem: true, isCondensed }))}
        </div>
    );
};

const FormDivider = () => <div className={styles.divider} />;

const FormLayout = ({ children }) => children;

FormLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

FormItem.propTypes = {
    children: PropTypes.node.isRequired,
    isGroupedItem: PropTypes.bool,
    isCondensed: PropTypes.bool,
};

FormFieldset.propTypes = {
    children: PropTypes.node.isRequired,
};

FormGroup.propTypes = {
    children: PropTypes.node.isRequired,
    isWeightedRight: PropTypes.bool,
    isWeightedLeft: PropTypes.bool,
    isCondensed: PropTypes.bool,
};

FormItem.defaultProps = {
    isGroupedItem: false,
    isCondensed: false,
};

FormGroup.defaultProps = {
    isWeightedRight: false,
    isWeightedLeft: false,
    isCondensed: false,
};

FormLayout.Item = FormItem;
FormLayout.Fieldset = FormFieldset;
FormLayout.Group = FormGroup;
FormLayout.Divider = FormDivider;

export default FormLayout;
